export const CABLE_LENGTH_CHARACTERISTIC = "cable_length"
export const CABLE_COLOR_CONNECTORS = "colour_connectors"
export const CABLE_TYPE = "cabletype"

export const CABLE_CONNECTION_SIDE_1 = "connection_side_1"
export const CABLE_CONNECTION_SIDE_2 = "connection_side_2"
export const CABLE_X_POLE = "x_pole"
export const CABLE_SERIES = "series_to_connect"

export const CABLE_MANUFACTURER_CHARACTERISTIC = "manufacturer"

export const CABLE_PRODUCT_IMAGE_CHARACTERISTIC = "product_image"
